import { useState } from "react"

export const usePincodeFormHandling = () => {
    const [formData,setFormData] = useState({
        countryId: "",
        stateId: "",
        districtId: "",
        cityId: "",
        code: "",
        active: true,

        countryIdStatus: "unchecked",
        stateIdStatus: "unchecked",
        districtIdStatus: "unchecked",
        cityIdStatus: "unchecked",
        codeStatus: "unchecked",

    });    
    
    const handleChange = (event,selectEvent) => {
        
        let formState ={...formData};

        if(event?.target === undefined && selectEvent){
            switch(selectEvent.name){
                
                case "countryId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,70})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }
                    // Reset below levels
                    formState.stateId = "";
                    formState.stateIdStatus = "unchecked";

                    formState.districtId = "";
                    formState.districtIdStatus = "unchecked";

                    formState.cityId = "";
                    formState.cityIdStatus = "unchecked";
                    break;
                }

                case "stateId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }
                    // Reset children
                    formState.districtId = "";
                    formState.districtIdStatus = "unchecked";

                    formState.cityId = "";
                    formState.cityIdStatus = "unchecked";
                    break;
                }

                case "districtId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }
                    //reset
                    formState.cityId = "";
                    formState.cityIdStatus = "unchecked";
                    break;
                }

                case "cityId": {
                    const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                    
                default: {
                    
                    formState[selectEvent.name] = event;
                    formState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
                    break;
                }
            }
            
            formState[selectEvent.name] = event;
        }
        else if(event && event.target){
            switch(event.target.name){
                case "code": {
                    const alphaNLenghthRegex = new RegExp("^[A-Za-z0-9\s-]{3,10}$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "iplBankId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,60})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                
                default: {

                    formState[event.target.name] = event.target.value;
                    formState[event.target.name + "Status"] =
                    event.target.value === "" ? "unchecked" : "success";
                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        setFormData(formState);
    
    }

    const checkAllFields = () => {
        let allowSubmit = false;

        if (
        formData.codeStatus === "success" &&
        formData.stateIdStatus === "success" &&
        formData.districtIdStatus === "success" &&
        formData.countryIdStatus === "success" &&
        formData.cityIdStatus === "success"
        ) {
        allowSubmit = true;
        } else {
        allowSubmit = false;
        }

        return allowSubmit;
    };

    return{
        formData,
        setFormData,
        handleChange,
        checkAllFields
    }
}